(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-quick-order"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class WholesaleQuickOrder extends HTMLElement {
      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('[data-wholesale-row]'));
        this.search = this.querySelector('[data-wholesale-search]');
        this.summary = this.querySelector('[data-wholesale-summary]');
        this.addButton = this.querySelector('[data-wholesale-add]');
        this.message = this.querySelector('[data-wholesale-message]');
        this.status = this.querySelector('[data-wholesale-status]');
        this.bindEvents();
        this.updateAll();
      }

      bindEvents() {
        this.rows.forEach((row) => {
          const variant = row.querySelector('[data-wholesale-variant]');
          const quantity = row.querySelector('[data-wholesale-quantity]');

          if (variant) {
            variant.addEventListener('change', () => this.updateRow(row));
          }

          if (quantity) {
            quantity.addEventListener('input', () => this.updateAll());
          }
        });

        if (this.search) {
          this.search.addEventListener('input', () => this.filterRows());
        }

        if (this.addButton) {
          this.addButton.addEventListener('click', () => this.addSelected());
        }
      }

      selectedOption(row) {
        const field = row.querySelector('[data-wholesale-variant]');

        if (!field) {
          return null;
        }

        if (field.tagName === 'SELECT') {
          return field.selectedOptions[0];
        }

        return field;
      }

      rowPrice(row) {
        const option = this.selectedOption(row);
        return option ? Number(option.dataset.price) || 0 : 0;
      }

      rowQuantity(row) {
        const input = row.querySelector('[data-wholesale-quantity]');
        const quantity = input ? Number(input.value) : 0;
        return Number.isFinite(quantity) && quantity > 0 ? Math.floor(quantity) : 0;
      }

      updateRow(row) {
        const option = this.selectedOption(row);
        const sku = row.querySelector('[data-wholesale-sku]');
        const price = row.querySelector('[data-wholesale-price]');
        const quantity = row.querySelector('[data-wholesale-quantity]');

        if (option) {
          if (sku) {
            sku.textContent = option.dataset.sku || '';
          }

          if (price) {
            price.textContent = this.money(Number(option.dataset.price) || 0);
          }

          if (quantity) {
            quantity.disabled = option.dataset.available !== 'true';
            if (quantity.disabled) {
              quantity.value = 0;
            }
          }
        }

        this.updateAll();
      }

      updateAll() {
        let total = 0;
        let items = 0;

        this.rows.forEach((row) => {
          const quantity = this.rowQuantity(row);
          const lineTotal = quantity * this.rowPrice(row);
          const lineTotalElement = row.querySelector('[data-wholesale-line-total]');

          total += lineTotal;
          items += quantity;

          if (lineTotalElement) {
            lineTotalElement.textContent = this.money(lineTotal);
          }
        });

        if (this.summary) {
          this.summary.textContent = this.money(total);
        }

        if (this.addButton) {
          this.addButton.disabled = items === 0;
        }
      }

      filterRows() {
        const term = this.search.value.trim().toLowerCase();
        let visibleRows = 0;

        this.rows.forEach((row) => {
          const isVisible = !term || row.dataset.searchText.includes(term);
          row.hidden = !isVisible;
          if (isVisible) {
            visibleRows += 1;
          }
        });

        if (this.status) {
          this.status.textContent = `${visibleRows} products shown`;
        }
      }

      selectedItems() {
        return this.rows
          .map((row) => {
            const option = this.selectedOption(row);
            const quantity = this.rowQuantity(row);

            if (!option || quantity < 1 || option.dataset.available !== 'true') {
              return null;
            }

            return {
              id: Number(option.value),
              quantity
            };
          })
          .filter(Boolean);
      }

      async addSelected() {
        const items = this.selectedItems();

        if (!items.length) {
          this.setMessage('Choose at least one quantity before adding to cart.', true);
          return;
        }

        this.addButton.disabled = true;
        this.setMessage('Adding selected items...', false);

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.description || 'Unable to add selected items.');
          }

          this.setMessage('Selected items were added to cart.', false);
          this.clearQuantities();

          if (this.dataset.redirectToCart === 'true') {
            window.location.href = this.dataset.cartUrl;
          }
        } catch (error) {
          this.setMessage(error.message || 'Unable to add selected items.', true);
        } finally {
          this.updateAll();
        }
      }

      clearQuantities() {
        this.rows.forEach((row) => {
          const quantity = row.querySelector('[data-wholesale-quantity]');

          if (quantity) {
            quantity.value = 0;
          }
        });
      }

      setMessage(text, isError) {
        if (!this.message) {
          return;
        }

        this.message.textContent = text;
        this.message.classList.toggle('wholesale-quick-order__message--error', isError);
      }

      money(cents) {
        const amount = Number(cents) / 100;

        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.dataset.currency || 'USD',
            maximumFractionDigits: amount % 1 === 0 ? 0 : 2
          }).format(amount);
        } catch (error) {
          return `$${amount.toFixed(amount % 1 === 0 ? 0 : 2)}`;
        }
      }
    }

    if (!customElements.get('wholesale-quick-order')) {
      customElements.define('wholesale-quick-order', WholesaleQuickOrder);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
